export default "__VITE_ASSET__RxBq2AxE__"